import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './tech-deep-dive.css'

const TechDeepDive = (props) => {
  return (
    <div id="TechDeepDiveId" className="tech-deep-dive-container">
      <a
        href={props.techDeepDiveTitleUrl}
        target="_blank"
        rel="noreferrer noopener"
        className="tech-deep-dive-title"
      >
        {props.techDeepDiveTitle ?? (
          <Fragment>
            <span className="tech-deep-dive-text11">Technical Deep Dive</span>
          </Fragment>
        )}
      </a>
      <span className="tech-deep-dive-text10">
        {props.techDeepDiveText ?? (
          <Fragment>
            <span className="tech-deep-dive-text12">
              <span className="tech-deep-dive-text13">Web development:</span>
              <span>
                {' '}
                Modern, fast, scalable – I create robust web applications using
                React and TypeScript for the frontend and Python, Java, or other
                modern backend technologies. From interactive user interfaces to
                secure APIs – everything tailored to your needs.
              </span>
              <br></br>
              <br></br>
              <span className="tech-deep-dive-text17">App development:</span>
              <span>
                {' '}
                Cross-platform and native apps for mobile devices. Whether Swift
                for iOS, Kotlin for Android, or React Native for both – I build
                intuitive, performant apps that work seamlessly across devices.
              </span>
              <br></br>
              <br></br>
              <span className="tech-deep-dive-text21">
                DevOps &amp; Infrastructure:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Reliable, automated, future-proof. I design and implement
                efficient DevOps pipelines with Docker, Kubernetes, AWS, GitLab,
                GitHub, Nexus, Terraform, Ansible, and more – ensuring your
                software runs securely and scalable in any environment.
              </span>
              <br></br>
              <br></br>
              <span className="tech-deep-dive-text25">
                Data Science &amp; AI Development:
              </span>
              <span>
                {' '}
                From raw data to smart solutions. I develop complete data
                pipelines and intelligent systems using Python, Rust, and modern
                frameworks – covering Data Engineering, Databases, MLOps, AI/ML
                Development, and Data Analysis.
              </span>
              <br></br>
              <br></br>
              <span className="tech-deep-dive-text29">
                Software &amp; System Architecture:
              </span>
              <span>
                {' '}
                Clear structures for complex systems. I design scalable, secure
                architectures – automatically generated with Mermaid or
                PlantUML, or manually refined in draw.io – tailored to your
                business requirements and future growth.
              </span>
            </span>
          </Fragment>
        )}
      </span>
    </div>
  )
}

TechDeepDive.defaultProps = {
  techDeepDiveTitle: undefined,
  techDeepDiveText: undefined,
  techDeepDiveTitleUrl: 'https://www.teleporthq.io',
}

TechDeepDive.propTypes = {
  techDeepDiveTitle: PropTypes.element,
  techDeepDiveText: PropTypes.element,
  techDeepDiveTitleUrl: PropTypes.string,
}

export default TechDeepDive
